module.exports = __webpack_public_path__ + "img/img36.7a87c6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img36.jpg
// module id = 334
// module chunks = 0